module.exports = __webpack_public_path__ + "media/images/front/columns_test_img_01-1765d5081f5ca46d23672c833a222733.jpg";